import * as PIXI from 'pixi.js';

export class Background extends PIXI.Sprite {
  constructor() {
    super(PIXI.Texture.from('BACKGROUND'));
  }
  public handleResize([width, height]: [number, number]): void {
    this.width = width;
    this.height = height;
  }
}
